import { DIVIDER_CSS_VARIABLES } from "@busbud/design-system-components/dist/Divider";

import { createStyles } from "../tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { colors } = theme.busbud;

  return {
    selected: {
      boxShadow: "unset",
      borderColor: colors.border.informative.transparent,
      backgroundColor: colors.background.informative.transparent
    },
    selectedSkeleton: {
      backgroundColor: colors.background.informative.transparent
    },
    divider: {
      [DIVIDER_CSS_VARIABLES.color]: colors.border.secondary.transparent
    }
  };
});
